module.exports = __webpack_public_path__ + "img/美容水(绿)_01.8c39a99b.jpg";